import {Component, OnInit} from '@angular/core';
import {BaseMetadataAbstract} from "../BaseMetadata.abstract";
import {FormControl, ValidatorFn, Validators} from '@angular/forms';

@Component({
    selector: 'app-meta-data-alszam',
    templateUrl: './meta-data-alszam.component.html',
    styleUrls: ['../metadata-style.scss'],
    standalone: false
})
export class MetaDataAlszamComponent extends BaseMetadataAbstract<string, string, string> implements OnInit{

  alszamFormControl!: FormControl;

  ngOnInit() {
    this.initializeFormControl();
    this.alszamFormControl.markAsTouched();
  }

  private initializeFormControl() {
    const alszamRegex = /^(?:([\p{L}\p{N} \w.!*_\/-]+)\/)?([0-9]+)-([0-9]+)\/((?:19|20)[0-9]{2})(?:\/([\p{L}\p{N} \w.!*_\/-]+))?$/u;
    const validators: ValidatorFn[] = [
      Validators.minLength(1),
      Validators.pattern(alszamRegex),
    ];

    if (this.visibility === 'MT_K') {
      validators.push(Validators.required);
    }

    this.alszamFormControl = new FormControl(this.value, validators);
  }

}
